import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { Discover, PerformanceType } from '@shared/interfaces';

@Injectable()
export class DiscoverService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getData(type?: PerformanceType): Observable<Discover> {
    let params: any = {};
    if (type) params.type = type;
    
    return this.http.get<Discover>(this.api.HOMEPAGE(), { params });
  }

}
